// extracted by mini-css-extract-plugin
module.exports = {"checkHere":"personalizedTag-module--check-here--1rLj-"};